/**
 * Idle time after the last keystroke before the search box commits on its own.
 *
 * Document search is deliberately submit-driven — Enter, the search button, or
 * this idle fallback — never per-keystroke. One search is three sequential
 * server hops (the unzipped-container pre-query, then `listDocuments` alongside
 * the `search_documents_by_content` RPC, then id hydration and link
 * enrichment), so firing one per character spends most of them on prefixes the
 * user was still typing through.
 *
 * Long enough to sit out a normal typing burst; short enough that someone who
 * types a term and looks up still gets results without touching the keyboard
 * again.
 */
export const DOCUMENT_SEARCH_IDLE_MS = 1200;
